import {useTheme} from '../../contexts/ThemeContext';

/**
 * SiteHTML - Returns theme-specific content for different sections.
 * Uses the theme context to get customized content, falling back to defaults.
 *
 * @param {Object} props
 * @param {'footer' | 'name' | 'disclaimer'} props.param - The content section to retrieve
 */
const SiteHTML = ({param}) => {
  const theme = useTheme();

  // Default footer content
  const defaultFooter = (
    <>
      <p>
        {theme.name} is happy to make this unique service available to our
        customers! Our proprietary heatshrink application allows you to select
        from our available combinations of heatshrink products and design your
        own customized heatshrink tubing. We offer a constantly expanding
        library of stock images, as well as text capabilities, to place on your
        tubing. You can even upload your company logo or other custom art to be
        saved into our database for your use in the future. Your finished art
        will be prepared by our Graphics Dept. and printed on our high
        resolution equipment.
      </p>
    </>
  );

  // Default disclaimer content
  const defaultDisclaimer = (
    <small>
      By placing your Heatshrink Printing order, you are giving implied consent
      for {theme.name} to use samples of your designs for promotional purposes. If
      you wish to opt out your heatshrink designs for these uses, please contact
      customer support.
    </small>
  );

  function getContent(section) {
    switch (section) {
      case 'footer': {
        const footer = theme.content?.footer;
        if (!footer) return defaultFooter;
        return typeof footer === 'string' ? <p>{footer}</p> : footer;
      }
      case 'name':
        return theme.name;
      case 'disclaimer':
        return theme.content?.disclaimer || defaultDisclaimer;
      default:
        return '';
    }
  }

  return getContent(param);
};

/**
 * Helper function to get site-specific content outside of component context.
 * @deprecated Use <SiteHTML param="..." /> or useTheme() hook instead.
 */
export function siteHTML(param) {
  // This is kept for backward compatibility but should be replaced with
  // the SiteHTML component or useTheme hook in consuming components
  console.warn('siteHTML function is deprecated. Use <SiteHTML param="..." /> component or useTheme() hook instead.');
  return param;
}

export default SiteHTML;
